import { Button, Stack, Text, useBreakpointValue } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { Tooltip } from '../ui/tooltip';

type NavAccordionItemChildProps = {
  text: string;
  textShort: string;
  icon: ReactElement;
  isOpen: boolean;
  onClick: () => void;
};

export function NavAccordionItemChild({ ...props }: NavAccordionItemChildProps) {
  const text = useBreakpointValue({ base: props.textShort, lg: props.text });

  const responsiveValues = {
    buttonPadding: {
      xs: '5',
      lg: '7',
      xl: '7',
    },
    textSize: {
      xs: 'small',
      lg: 'medium',
      xl: 'medium',
    },
  };

  return (
    <Button
      pl={6}
      variant="ghost"
      width="full"
      maxHeight="8"
      minHeight="8"
      onClick={props.onClick}
      color="secondaryText"
      _focus={{ bg: 'cardDefault' }}
      _hover={{ bg: 'cardHover', transition: 'background-color 0.2s' }}
      _active={{ bg: 'cardActive', transition: 'background-color 0.2s' }}
    >
      {props.icon}
      <Stack
        direction="row"
        width="full"
        alignItems="center"
        justifyContent={props.isOpen ? 'flex-start' : 'center'}
      >
        <Tooltip content={props.text} openDelay={1000} positioning={{ placement: 'right' }}>
          <Text
            fontSize="medium"
            textAlign={props.isOpen ? 'left' : 'center'}
            alignContent="center"
            transition="hideBelow 1s"
            width={180}
            fontWeight={600}
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
            display={props.isOpen ? 'block' : 'none'}
          >
            {text}
          </Text>
        </Tooltip>
      </Stack>
    </Button>
  );
}
